<template>
  <div class="row-book" @click="submitButton(props.info)">
    <!-- <img src="@/assets/Rectangle 1115.png" alt="" /> -->
    <slot name="rowBook"></slot>
    <div class="box-p">
      <p style="cursor: pointer">
        <!-- 二轮复习必备神器二轮复习必备神器 -->
        {{ props.info.title }}
      </p>
      <p style="cursor: pointer">
        适用地区：
        <template v-for="(item,index) in props.info.apply_area" :key="index">{{item.city_name}}</template>
        
      </p>
      <p style="cursor: pointer">
        适用年级：
        {{ props.info.apply_grade }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";

const router = useRouter();

const props = defineProps({
  path: {
    type: String,
    default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

//按钮点击事件
function submitButton(val) {
  if (!val.outPage) {
    router.push({
      path: props.path,
      query: { id: val.id },
    });
  } else {
    if (val.path) {
      window.open(val.path);
    }
  }
}
</script>

<style scoped lang="scss">
.row-book {
  width: 288px;
  //width: 100%;
  //height: 120px;
  // border: 1px solid rgb(38, 0, 255);
  display: flex;
  // img {
  //   width: 120px;
  //   eight: 120px;
  //   margin-right: 12px;
  //   }

  .box-p {
    // border:1px solid blue;
    p:nth-of-type(1) {
      font-size: 16px;
      font-weight: 400px;
      color: #333333;
      line-height: 24px;
      margin-bottom: 12px;

      // height: 48px;
      min-height:24px;
      line-height: 24px;

      display: -webkit-box;
      -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
      text-overflow: ellipsis; //文本溢出 用省略号显示
      -webkit-line-clamp: 2; //几行
      overflow: hidden;
    }
    >p:nth-of-type(1):hover{
      color:#009DE0;
    }
    p:nth-of-type(2),
    p:nth-of-type(3) {
      font-size: 14px;
      // font-size: 15px;
      font-weight: 400px;
      line-height: 22px;
      color: #666666;
      
      white-space: nowrap; //不折行
      text-overflow: ellipsis; //文本溢出 用省略号显示
      overflow: hidden;
      width: 180px;
      // height: 48px;
      // line-height: 24px;
      // display: -webkit-box;
      // -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
      // text-overflow: ellipsis; //文本溢出 用省略号显示
      // -webkit-line-clamp: 2; //几行
      // overflow: hidden;
    }
  }
}
</style>
